<template>
  <p class="date-holder">
    <icon
      width="18"
      height="18"
      :name="icon"
      :color="iconColor"
      :fill="iconFill"
      class="icon"
      v-if="showIcon"
    />
    <span v-if="title">{{ title }}{{ "&nbsp;" }}</span>
    <time :datetime="date" v-if="date">{{ dateString }}</time>
  </p>
</template>

<script>
export default {
  props: {
    date: {
      type: [String, Date, Number],
      default: new Date().toString(),
    },
    title: {
      type: String,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "clock",
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    endTime: {
      type: String,
      default: "",
    },
    relative: {
      type: Boolean,
      default: false,
    },
    iconFill: {
      type: Boolean,
      default: true,
    },
    iconColor: {
      type: String,
      default: "#64727E",
    },
  },
  computed: {
    dateString() {
      if (this.relative) {
        const posted = this.$dayjs(this.date);
        return this.$dayjs().to(posted);
      }
      const format = this.showTime ? "DD / MM / YYYY HH:mma" : "DD / MM / YYYY";

      const output =
        typeof this.date === "number"
          ? this.$dayjs.unix(this.date).format(format)
          : this.$dayjs(this.date).format(format);

      if (this.endTime && this.showTime) {
        // TODO: endtime is only for events where we have duration instead.
        // Should we calculate the time here or in the parent?
        const endTime = this.$dayjs(this.date)
          .add(this.endTime, "minute")
          .format("HH:mma");

        return `${output} - ${endTime}`;
      }

      return output;
    },
  },
};
</script>

<style scoped lang="scss">
.date-holder {
  display: inline-flex;
  align-items: flex-end;
  line-height: 0.875rem;
  margin: 0;
  padding: 0;
  font-weight: normal;
  font-size: 14px;
  color: #64727e;
}
.icon {
  margin-right: 5px;
  // fill: #64727E;
}
</style>
